import ReasonsForActionsCard from "./ReasonsForActionsCard";
import Style from "./ReasonsForActions.module.css";
import { useI18n } from "../../../i18n/I18nContext";

const testimonialImages = ["/solo-air.webp", "/modern-house.webp"];

const ReasonsForActionsSection = () => {
  const { copy } = useI18n();

  return (
    <div
      className={Style["reasons-section-wrapper"]}
      style={{ backgroundImage: `url("/testimonial_background.webp")` }}
    >
      <h2>{copy.home.testimonials.title}</h2>
      <div className={Style["section-body"]}>
        {copy.home.testimonials.items.map((description, index) => (
          <ReasonsForActionsCard
            key={testimonialImages[index]}
            imageSrc={testimonialImages[index]}
            description={description}
          />
        ))}
      </div>
    </div>
  );
};

export default ReasonsForActionsSection;
